import React,{useState} from 'react'
import GameRoutes from '../../route/gameroutes/GameRoutes'
import SearchBar from '../../route/searchbar/SearchBar'
import Token from '../../component/token/Token'
import './MolenPage.scss'
import ceklis from '../../assets/ceklis.png'
import molen from '../../assets/molen.png'
import Terms from '../../component/termsmodal/Terms'
import Activation from '../../component/activation/Activation'

const MolenPage = () => {
    const [show,setShow] = useState(false)
    const [show2,setShow2] = useState(false)
    const [show3,setShow3] = useState(false)
    const [show4,setShow4] = useState(false)

    const [showAct,setShowAct] = useState(false)


    const close = () => {
        setShow(false)
        setShow2(false)
        setShow3(false)
        setShow4(false)
        setShowAct(false)
    }

    
    const func2 = () => {
        alert('molen2')
    }

    return (
        <>
            <div className="molen__white">
                <div className="molen__container">
                    <SearchBar/>
                    <GameRoutes/>
                    <div className="molen__header">
                        <div className="molen__text">
                            <p>ML</p>
                        </div>
                        <div className="molen__activated" onClick={() => setShowAct(true)}>
                            <img src={ceklis} alt="ceklis"/>
                            <p>Activated</p>
                        </div>
                    </div>
                    <Token onClick={() => setShow(true)} onClick2={() => setShow2(true)} onClick3={() => setShow3(true)} onClick4={() => setShow4(true)}/>
                        {show && <Terms bgCover="molen--modal" header="SOLO LEAGUE" onClose={close} imagelogo={molen} onPay={func2}/>}
                        {show2 && <Terms bgCover="molen--modal" header="SOLO Challange" onClose={close} imagelogo={molen}/>}
                        {show3 && <Terms bgCover="molen--modal" header="TEAM Round of 8" onClose={close} imagelogo={molen}/>}
                        {show4 && <Terms bgCover="molen--modal" header="TEAM LEAGUE" onClose={close} imagelogo={molen}/>}
                        {showAct && <Activation bgCover="molen--bg" onClose={close} imageLogo={molen}/>}
                </div>
            </div>
        </>
    )
}

export default MolenPage
